import React from 'react';
import { Stack } from '@mui/material';
import { getScopes, isCMPAdmin } from 'utils';
import { Route, Switch } from 'react-router-dom';
import { SecureRoute } from '@okta/okta-react';
import SqlPaasProvisioningPage from 'pages/provisioning/sql';
import OracleProvisioningPage from 'pages/provisioning/oracle';
import IaaSSQLProvisioningPage from 'pages/provisioning/iaas-sql';
import StorageProvisioningPage from 'pages/provisioning/storage';
import AksProvisioningPage from 'pages/provisioning/aksns';
import AksVsProvisioningPage from 'pages/provisioning/aksns-virtual-service';
import KeyVaultProvisioningPage from 'pages/provisioning/key-vault';
import NSGProvisioningPage from 'pages/provisioning/nsg-common-rule';
import AlbProvisioningPage from 'pages/provisioning/alb';
import PrivateEndpointProvision from 'pages/provisioning/private-endpoint';
import PrivateEndpointProvision2 from 'pages/provisioning/private-endpoint-v2';
import KafkaProvisioningPage from 'pages/provisioning/kafka';
import Day2OperationPage from 'pages/provisioning/day2-operation';
import Day2OperationPaasPage from 'pages/provisioning/day2-operation-paas';
import EventHubProvisioningPage from 'pages/provisioning/event-hub';
// import EipStackProvisioningPage from 'pages/provisioning/eip-stack';
import CouchbaseProvisioning from 'pages/provisioning/couchbase';
import AzueDataFactoryProvision from 'pages/provisioning/azure-data-factory';
import MyIdm from 'pages/myidm';
import OnboardDevelopers from 'pages/onboard-developers';
import ServiceAccountCreation from 'pages/service-account-creation';
// import MdtOnboarding from 'pages/mdt-onboarding/provisioning';
import LandingPageHarmonization from 'pages/landing-page-harmonization';
import AWSEC2ProvisioningPage from 'pages/provisioning/aws/ec2';
import AWSOracleRDSProvisioningPage from 'pages/provisioning/aws/oracle-rds';
import AWSS3BucketProvisioningPage from 'pages/provisioning/aws/s3-bucket';
import AWSSNSProvisioningPage from 'pages/provisioning/aws/sns';
import AWSSQSProvisioningPage from 'pages/provisioning/aws/sqs';
import AWSOracle19CProvisioningPage from 'pages/provisioning/aws/oracle-19c';
import DynamoDbProvisioningPage from 'pages/provisioning/aws/dynamo-db';
import AwsAlbProvisioningPage from 'pages/provisioning/aws/alb';
import AwsNlbProvisioning from 'pages/provisioning/aws/nlb';
import AWSExternalNlbPage from 'pages/provisioning/aws/external-nlb';
import AwsEksnProvisioningPage from 'pages/provisioning/aws/eks-namespace';
import PostgreSQLProvisioningPage from 'pages/provisioning/azure/postgre-sql';
import MySQLProvisioningPage from 'pages/provisioning/azure/mysql';
import AWSCloudOnboardingProvisioning from 'pages/provisioning/aws/cloud-onboarding';
import AwsAccountVendingProvisioning from 'pages/provisioning/aws/account-vending';
import WindowsProvisioningPage from 'pages/provisioning/azure/windows';
import CustomBuildProvisioningPage from 'pages/provisioning/azure/custom-build';
import LinuxProvisioningPage from 'pages/provisioning/azure/linux';
import PgtSapSolutionPage from 'pages/provisioning/azure/pgt-sap-solution';
import AWSInternalUrlOnboardProvisioningPage from 'pages/provisioning/aws/internal-url-onboarding';
import AWSExternalUrlOnboardProvisioningPage from 'pages/provisioning/aws/external-url-onboarding';
import PrivateCloudWindowsVmProvisioningPage from 'pages/provisioning/private-cloud/windows-vm';
import PCLinuxVmProvisioning from 'pages/provisioning/private-cloud/linux-vm';
import PCSqlIaasProvisioning from 'pages/provisioning/private-cloud/sql-iaas';
import PCOracleDBProvisioning from 'pages/provisioning/private-cloud/oracledb-19c';
import AwsKafkaTopicProvisioningPage from 'pages/provisioning/aws/kafka-topic';
import AWSDocumentDBProvisioningPage from 'pages/provisioning/aws/document-db';
import {
    LandingPage,
    // LandingPageNew,
    OrdersPage,
    VmProvisioningPage,
    PgcsVmProvisioningPage,
    ApprovalsPage,
    PageNotFound,
    SkuPage,
    HelpDoc,
    // NewArticle,
    AppProfilePage,
    AppProfileDetailsPage,
    AppProfileDetailsPageNew,
    AppDefaultPage,
    LandingZonePage,
    Services,
    Dashboard,
    DashboardNew,
    Cart,
    Catalogs,
    InventoryList,
    AnnouncementsPage,
    IpamAdminPage,
} from 'pages';
import CreateAnnouncement from 'pages/announcements/CreateAnnouncement';
import EditAnnouncement from 'pages/announcements/EditAnnouncement';
// import SecurityTool from 'pages/security-tool';
import DashboardEnhancement from 'pages/dashboard-enhancement';
import RiServices from 'pages/reference-implementation/services';
import RiProvisioning from 'pages/reference-implementation/provisioning';
import SsoOktaPage from 'pages/sso-okta';
import ssoOktaModification from 'pages/sso-okta-modification';
import ApplicationGateWayProvisioning from 'pages/provisioning/application-gateway';
import InternalApplicationGateWayProvisioning from 'pages/provisioning/internal-application-gateway';
import OnboardAppService from 'pages/onboard-app-service';
import ProjectOnboarding from 'pages/project-onboarding';
import GithubOnboardingNewPage from 'pages/provisioning/day2/github-onboarding-new';
import CloudOnboardingProvisioning from 'pages/cloud-onboarding';
import DlopsProjectDashboard from 'pages/dlops-dashboard/projectDashboard';
import DlopsRegisteredModels from 'pages/dlops-dashboard/registeredModels';
import DlopsModelVersions from 'pages/dlops-dashboard/modelVersions';
import DlopsObservabilityModel from 'pages/dlops-dashboard/modelObservability';
import DlopsDriftImages from 'pages/dlops-dashboard/ModelDriftImages';
import DlopsModelComparision from 'pages/dlops-dashboard/modelComparision';
import DlopsModelOnboarding from 'pages/dlops-dashboard/modelOnBoarding';
import DlopsNewModelCreation from 'pages/dlops-dashboard/modelOnBoarding/createNewModel';
import DlopsNewModelTags from 'pages/dlops-dashboard/modelOnBoarding/createNewModelTags';
import DlopsEditExistingProject from 'pages/dlops-dashboard/editProjects';
import DlopsEditExistingModel from 'pages/dlops-dashboard/editProjects/editExistingModel';
import DlopsEditExistingModeltags from 'pages/dlops-dashboard/editProjects/editExistingModelTags';
import DlopsAddNewModel from 'pages/dlops-dashboard/addNewModel';
import DlopsAddNewModelTags from 'pages/dlops-dashboard/addNewModel/addNewModelTags';
import VirtualService from 'pages/provisioning/virtual-service';
import NewInternalAppGateWayProvisioning from 'pages/provisioning/internal-app-gateway-provisioning';
import AWSLexProvisioningPage from 'pages/provisioning/aws/lex';
import AWSLambdaProvisioningPage from 'pages/provisioning/aws/lambda-function';
import NsgAutomationProvisioning from 'pages/provisioning/nsg-automation-rules';
import UserPreferences from 'pages/user-preferences';
import PgcsIaaSSQLProvisioningPage from 'pages/provisioning/pgcs-iaas-sql';
import CosmosDBProvisioningPage from 'pages/provisioning/azure/cosmosDb';
import OracleExadataProvisioningPage from 'pages/provisioning/azure/oracle-exadata';
import EdapNodePoolProvisioningPage from 'pages/provisioning/azure/edap-node-pool';
import { SCOPE_EDAP_ADMIN, SCOPE_ORDER_MGMT_WRITE } from 'utils/scope';
import CatalogRouteGuard from './CatalogRouteGuard';

const style = {
    // flex: '1 1 0%',
    // display: 'flex',
    overflow: 'hidden',
    minHeight: 'calc(100vh - 98px)',
};

const AZ_WINDOWS_CATALOG_CODES = ['AZWINVM2016', 'AZWINVM2019', 'AZWINVM2022', 'AZWINVM2025'];
const AZ_CUSTOM_BUILD_CATALOG_CODES = ['AZCBVM'];
const AZ_LINUX_CATALOG_CODES = ['AZRHEL8VM', 'AZOEL8VM', 'AZSLES15VM'];
const PRIVATE_CLOUD_WINDOWS_CATALOG_CODES = ['NUTANICWINVM'];
const PRIVATE_CLOUD_LINUX_CATALOG_CODES = ['NUTANICSLINUXVM'];
const PRIVATE_CLOUD_SQL_CATALOG_CODES = ['NUTANIXSQLDB'];
const PRIVATE_CLOUD_ORACLE_DB_CATALOG_CODES = ['NUTANIXOELDB'];

const MainRoute = [
    { path: '/landing', component: LandingPage, allowedScopes: [] },
    // { path: '/', component: LandingPageNew, allowedScopes: [] },
    { path: '/', component: LandingPageHarmonization, allowedScopes: [] },
    { path: '/dashboard-old', component: Dashboard, allowedScopes: ['orderMgmt.write', 'CMPDashboardViewer'] },
    { path: '/dashboard-new', component: DashboardNew, allowedScopes: ['orderMgmt.write', 'CMPDashboardViewer'] },
    { path: '/dashboard', component: DashboardEnhancement, allowedScopes: ['orderMgmt.write', 'CMPDashboardViewer'] },
    // { path: '/pepvigil-overview-dashboard', component: DlopsDashboard, allowedScopes: [] },
    { path: '/pepvigil-projects', component: DlopsProjectDashboard, allowedScopes: [] },
    { path: '/pepvigil-registered-models', component: DlopsRegisteredModels, allowedScopes: [] },
    { path: '/pepvigil-model-versions', component: DlopsModelVersions, allowedScopes: [] },
    { path: '/pepvigil-model-observability', component: DlopsObservabilityModel, allowedScopes: [] },
    { path: '/pepvigil-drift-images', component: DlopsDriftImages, allowedScopes: [] },
    { path: '/pepvigil-model-comparision', component: DlopsModelComparision, allowedScopes: [] },
    { path: '/pepvigil-model-onboarding', component: DlopsModelOnboarding, allowedScopes: [] },
    { path: '/pepvigil-new-modelCreation', component: DlopsNewModelCreation, allowedScopes: [] },
    { path: '/pepvigil-new-modeltags', component: DlopsNewModelTags, allowedScopes: [] },
    { path: '/pepvigil-edit-existing-project', component: DlopsEditExistingProject, allowedScopes: [] },
    { path: '/pepvigil-edit-existing-model', component: DlopsEditExistingModel, allowedScopes: [] },
    { path: '/pepvigil-edit-existing-modeltags', component: DlopsEditExistingModeltags, allowedScopes: [] },
    { path: '/pepvigil-add-new-model', component: DlopsAddNewModel, allowedScopes: [] },
    { path: '/pepvigil-add-newmodeltags', component: DlopsAddNewModelTags, allowedScopes: [] },
    { path: '/orders', component: OrdersPage, allowedScopes: [] },
    {
        path: '/vm-provisioning/:osType/:serverType/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        render: (props) => {
            const { catalogCode } = props.match.params;
            if (PRIVATE_CLOUD_WINDOWS_CATALOG_CODES.includes(catalogCode)) {
                return <PrivateCloudWindowsVmProvisioningPage {...props} />;
            }
            if (PRIVATE_CLOUD_LINUX_CATALOG_CODES.includes(catalogCode)) {
                return <PCLinuxVmProvisioning {...props} />;
            }
            if (PRIVATE_CLOUD_SQL_CATALOG_CODES.includes(catalogCode)) {
                return <PCSqlIaasProvisioning {...props} />;
            }
            if (PRIVATE_CLOUD_ORACLE_DB_CATALOG_CODES.includes(catalogCode)) {
                return <PCOracleDBProvisioning {...props} />;
            }
            if (AZ_CUSTOM_BUILD_CATALOG_CODES.includes(catalogCode)) {
                return <CustomBuildProvisioningPage {...props} />;
            }
            if (AZ_WINDOWS_CATALOG_CODES.includes(catalogCode)) {
                return <WindowsProvisioningPage {...props} />;
            }
            if (AZ_LINUX_CATALOG_CODES.includes(catalogCode)) {
                return <LinuxProvisioningPage {...props} />;
            }
            return <VmProvisioningPage {...props} />;
        },
        allowedScopes: [],
    },
    {
        path: '/pgcs-vm-provisioning/:osType/:serverType/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        component: PgcsVmProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/oracle-provisioning/:osType/:serverType/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        component: OracleProvisioningPage,
        allowedScopes: [],
    },
    { path: '/sql-paas-provisioning/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?', component: SqlPaasProvisioningPage, allowedScopes: [] },
    {
        path: '/iaas-sql-provisioning/:osType/:serverType/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        component: IaaSSQLProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/pgcs-iaas-sql-provisioning/:osType/:serverType/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        component: PgcsIaaSSQLProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/azure-storage-provisioning/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        component: StorageProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/aks-nms-provisioning/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        component: AksProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/edap-aks-nms-provisioning/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        component: AksVsProvisioningPage,
        allowedScopes: [SCOPE_EDAP_ADMIN],
    },
    {
        path: '/azure-key-vault/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        component: KeyVaultProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/nsg-common-rule/:catalogCode',
        component: NSGProvisioningPage,
        allowedScopes: ['orderMgmt.write', 'nsg.write'],
    },
    {
        path: '/azure-load-balancer/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        component: AlbProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/kafka-topic-provisioning/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        component: KafkaProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/private-endpoint-provisioning/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        component: PrivateEndpointProvision2,
    },
    {
        path: '/private-endpoint-provisioning-old/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        component: PrivateEndpointProvision,
    },
    {
        path: '/day2-operation/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        component: Day2OperationPage,
        allowedScopes: [],
    },
    {
        path: '/day2-operation-paas/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        component: Day2OperationPaasPage,
        allowedScopes: [],
    },
    {
        path: '/event-hub-provisioning/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        component: EventHubProvisioningPage,
        allowedScopes: [],
    },
    // {
    //     path: '/app-microservices-stack/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
    //     component: EipStackProvisioningPage,
    //     allowedScopes: [],
    // },
    {
        path: '/couchbase-provisioning/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        component: CouchbaseProvisioning,
        allowedScopes: [],
    },
    {
        path: '/azure-data-factory-provisioning/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        component: AzueDataFactoryProvision,
        allowedScopes: [],
    },
    { path: '/approvals', component: ApprovalsPage, allowedScopes: [] },
    { path: '/sku', component: SkuPage, allowedScopes: ['orderMgmt.write'] },
    { path: '/help', component: HelpDoc, allowedScopes: [] },
    // {
    //     path: '/access-management-myidm',
    //     component: MyIdm,
    //     allowedScopes: ['orderMgmt.write'],
    // },
    {
        path: '/access-management-myidm/:catalogCode/:operation?/:orderId?/:catalogServiceId?',
        component: MyIdm,
        allowedScopes: [],
    },
    {
        path: '/service-account-creation/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        component: ServiceAccountCreation,
        allowedScopes: [],
    },
    {
        path: '/service-account-ci/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        component: ServiceAccountCreation,
        allowedScopes: [],
    },

    // { path: '/new-article', component: NewArticle, allowedScopes: [] }, // commented since we parked this feature.
    { path: '/app-profile', component: AppProfilePage, allowedScopes: [] },
    { path: '/app-details-new/:id', component: AppProfileDetailsPage, allowedScopes: [] },
    { path: '/app-details/:id/:operation?/:landingZoneId?', component: AppProfileDetailsPageNew, allowedScopes: [] },
    { path: '/app-default', component: AppDefaultPage, allowedScopes: [] },
    { path: '/landing-zones/:appProfileName/:appProfileId', component: LandingZonePage, allowedScopes: [] },
    { path: '/landing-zones/:appProfileName/:appProfileId/:profileType', component: LandingZonePage, allowedScopes: [] },
    { path: '/services', component: Services, allowedScopes: [] },
    { path: '/cart', component: Cart, allowedScopes: [] },
    { path: '/catalogs/:catalogDefinitionId?', component: Catalogs, allowedScopes: ['orderMgmt.write'] },
    { path: '/inventory-list', component: InventoryList, allowedScopes: [] },
    { path: '/announcements/create', component: CreateAnnouncement, allowedScopes: ['orderMgmt.write'] },
    { path: '/announcements/edit/:id', component: EditAnnouncement, allowedScopes: ['orderMgmt.write'] },
    { path: '/announcements', component: AnnouncementsPage, allowedScopes: ['orderMgmt.write'] },
    { path: '/ipam-adminportal', component: IpamAdminPage, allowedScopes: ['orderMgmt.write'] },
    { path: '/sso-okta-onboarding/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?', component: SsoOktaPage, allowedScopes: [] },
    { path: '/sso-okta-modification/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?', component: ssoOktaModification, allowedScopes: [] },
    { path: '/onboard-application-service/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?', component: OnboardAppService, allowedScopes: [] },
    // { path: '/security-tool/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?', component: SecurityTool, allowedScopes: [] },
    { path: '/project-onboarding/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?', component: ProjectOnboarding, allowedScopes: [] },
    { path: '/github-onboarding/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?', component: GithubOnboardingNewPage, allowedScopes: [] },
    { path: '/user-preferences/:operation?/:id?', component: UserPreferences, allowedScopes: [] },
    // RI Modules
    { path: '/reference-implementation-services', component: RiServices, allowedScopes: [] },
    {
        path: '/reference-implementation-provisioning/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        component: RiProvisioning,
        allowedScopes: [],
    },
    {
        path: '/access-management-onboard-developers/:catalogCode?',
        component: OnboardDevelopers,
        allowedScopes: [],
    },
    {
        path: '/azure-application-gateway-url-onboarding/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        component: ApplicationGateWayProvisioning,
        allowedScopes: [],
    },
    {
        path: '/azure-internal-application-gateway-url-onboarding/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        component: InternalApplicationGateWayProvisioning,
        allowedScopes: [],
    },
    {
        path: '/azure-external-public-load-balancer-url-onboarding/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        component: ApplicationGateWayProvisioning,
        allowedScopes: [],
    },
    {
        path: '/azure-new-internal-application-gateway-provisioning/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        component: NewInternalAppGateWayProvisioning,
        allowedScopes: [],
    },
    // {
    //     path: '/mdt-onboarding',
    //     component: MdtOnboarding,
    //     allowedScopes: [],
    // },
    {
        path: '/aks-vs-provisioning/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        component: VirtualService,
        allowedScopes: [],
    },
    {
        path: '/application-nsgrules-automation/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        component: NsgAutomationProvisioning,
        allowedScopes: [],
    },
    {
        path: '/cloud-adoption/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: CloudOnboardingProvisioning,
        allowedScopes: [],
    },
    {
        path: '/aws-vm-provisioning/Windows/WindowsServer/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: AWSEC2ProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/aws-vm-provisioning/Linux-Rhel/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: AWSEC2ProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/aws-vm-provisioning/Linux-Rhel-Custom-Build/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: AWSEC2ProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/aws-vm-provisioning/Linux/SLES/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: AWSEC2ProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/aws-vm-provisioning/Linux-OEL/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: AWSEC2ProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/aws-provisioning/oracle-rds/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: AWSOracleRDSProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/aws-provisioning/sql-rds/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: AWSOracleRDSProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/aws-provisioning/mysql-rds/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: AWSOracleRDSProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/aws-provisioning/lambda/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: AWSLambdaProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/aws-s3-provisioning/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: AWSS3BucketProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/aws-provisioning/dynamodb-rds/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: DynamoDbProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/aws-provisioning/postgresql-rds/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: AWSOracleRDSProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/aws-iaas-sql-provisioning/Windows/WindowsServer/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: AWSOracle19CProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/aws-oracle-provisioning/Linux/OEL/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: AWSOracle19CProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/aws-application-load-balancer/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: AwsAlbProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/aws-network-load-balancer/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: AwsNlbProvisioning,
        allowedScopes: [],
    },
    {
        path: '/aws-external-nlb-instance/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: AWSExternalNlbPage,
        allowedScopes: [],
    },
    {
        path: '/azure-postgresql-flexible-database/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: PostgreSQLProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/azure-mysql-flexible-database/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: MySQLProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/awscloud-adoption/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: AWSCloudOnboardingProvisioning,
        allowedScopes: [],
    },
    {
        path: '/awsaccount-onboard/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: AwsAccountVendingProvisioning,
        allowedScopes: [],
    },
    {
        path: '/aws-internal-url-onboarding/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: AWSInternalUrlOnboardProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/aws-external-url-onboarding/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: AWSExternalUrlOnboardProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/aws-eks-nms-provisioning/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: AwsEksnProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/azure-cosmos-database/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: CosmosDBProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/azure-oracle-exadata-database-provisioning/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: OracleExadataProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/aws-lexbot-provisioning/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: AWSLexProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/aws-sns-provisioning/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: AWSSNSProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/aws-sqs-provisioning/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: AWSSQSProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/aws-kafka-topic-provisioning/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: AwsKafkaTopicProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/edap-azure-nodepool-provisioning/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: EdapNodePoolProvisioningPage,
        allowedScopes: [SCOPE_EDAP_ADMIN, SCOPE_ORDER_MGMT_WRITE],
    },
    {
        path: '/aws-documentdb-provisioning/:catalogCode?/:operation?/:cartItemId?/:catalogServiceId?',
        component: AWSDocumentDBProvisioningPage,
        allowedScopes: [],
    },
    {
        path: '/azure-pgt-sap-sle5-vm-provisioning/:catalogCode/:operation?/:cartItemId?/:catalogServiceId?',
        component: PgtSapSolutionPage,
        allowedScopes: [],
    },
];

function ModuleRouter() {
    // const AccessRoles = getUserRoles();
    const AccessScopes = getScopes();

    return (
        <Stack style={style}>
            <Switch>
                {MainRoute.map((route, index) => {
                    // const isRoleAllowed =
                    //     !route?.allowedRoles || route?.allowedRoles?.length === 0 || route?.allowedRoles?.some((role) => AccessRoles?.includes(role));
                    const isScopeAllowed =
                        !route?.allowedScopes || route?.allowedScopes?.length === 0 || route?.allowedScopes?.some((scope) => AccessScopes?.includes(scope));
                    // if (isRoleAllowed && isScopeAllowed) {
                    if (isCMPAdmin() || isScopeAllowed) {
                        // For routes with :catalogCode, apply announcement restriction guard
                        if (route.path.includes(':catalogCode')) {
                            return (
                                <SecureRoute
                                    key={`route-${index.toString()}`}
                                    exact
                                    path={route.path}
                                    render={(props) => <CatalogRouteGuard component={route.component} render={route.render} {...props} />}
                                />
                            );
                        }
                        if (route.render) {
                            return <SecureRoute key={`route-${index.toString()}`} exact path={route.path} render={(props) => route.render(props)} />;
                        }
                        return <SecureRoute key={`route-${index.toString()}`} exact path={route.path} component={route.component} />;
                    }

                    return null;
                })}
                <Route path="*" component={PageNotFound} />
            </Switch>
        </Stack>
    );
}

export default ModuleRouter;
